export default __webpack_public_path__ + "static/media/address.c93d24fb.svg";